module.exports = __webpack_public_path__ + "static/media/verified.600e77f4.svg";